<template>
  <div class="general-wrapper">
    <Header />

    <PageContainer>
      <div class="iqos-grid">
        <div class="iqos-column">
          <WorkingSchedulePanel />
          <WorkingSchedulePanel mode="delivery"/>
        </div>
        <div class="iqos-column">
          <WorkingSchedulePanel mode="preorder"/>
        </div>
      </div>
    </PageContainer>
  </div>
</template>

<script>
import WorkingSchedulePanel from '@/components/general/WorkingSchedulePanel.vue';

export default {
  components: {
    WorkingSchedulePanel,
  }
};
</script>

<style></style>
